import { sdGatewayClient } from '../http/sdGatewayClient';
import { BlockSummaryReportVersion } from '../models/AccountGroupConfig';
import { deepCamelCase } from '../utils/camelCase';
import { deepSnakeCase } from '../utils/snakeCase';

export type UserPreferences = {
  contactGuid: string;
  accountGroup?: number;
  emailRecipient?: string;
  emailExports?: string[];
  vehiclesPerPage?: number;
  /**
   * These are account GUIDs (as found in Vicki AccountDetails)
   */
  deselectedAccounts?: string[];
  blockSummaryReportVersion: BlockSummaryReportVersion;
  includeRunReservations?: boolean;
  accountNumber?: string;
  accountName?: string;
};

export const userPreferencesService = {
  async get(contactGuid: string) {
    return deepCamelCase(
      (await sdGatewayClient.get(`/seller-dashboard/api/user_preferences/v2/${encodeURIComponent(contactGuid)}`)).data
    ) as UserPreferences;
  },

  async update(contactGuid: string, userPreferences: Partial<UserPreferences>) {
    await sdGatewayClient.patch<void>(
      `/seller-dashboard/api/user_preferences/v2/${encodeURIComponent(contactGuid)}`,
      deepSnakeCase({ userPreferences })
    );
  }
};
